import React from 'react';
import { Button, Modal } from 'antd';
import { CloseIcon } from '../../../assets/icons';
import { dateFormulationForModal } from '../../../utils/getDateForModal';
import { getUsCurrencyFormat } from '../../../utils/usCurrencyFormatter';
import { useNavigate } from 'react-router-dom';

const TransactionDetailsModal = (props) => {
  const navigate = useNavigate();
  const { transactionDetailsOpen, setTransactionDetailsOpen, modalTransactionData } = props;
  const { transactionId, initiatedOn, transactionType, status, amount, tradeDetails, dividendDetails, platformFee } = modalTransactionData;
  const amountWithoutFee = amount - platformFee;
  const transactionFee = amountWithoutFee * 0.01;
  const pricePerShare = (amount - platformFee) / tradeDetails?.noOfShares;
  return (
    <Modal
      open={transactionDetailsOpen}
      width={524}
      footer={false}
      closeIcon={<CloseIcon />}
      TransactionDetails
      onCancel={() => setTransactionDetailsOpen(false)}
      centered
    >
      <h4 className='text-center mb-24'>Transaction details</h4>
      <p className='fw-600 mb-0'>Order number:</p>
      <p className='text-taupe'>{transactionId}</p>
      <p className='fw-600 mb-0'>Initiated on:</p>
      <p className='text-taupe'>{dateFormulationForModal(initiatedOn, true)} (EST)</p>
      <p className='fw-600 mb-0'>Status:</p>
      <p className='text-taupe'>{status}</p>
      {/* Adding this as per requiremtns from this bug A0TG-I991 */}
      {transactionType !== 'Deposit' && transactionType !== 'Withdrawal' && transactionType !== 'Dividend' && (
        <>
          {tradeDetails?.marketPlace !== 'Secondary' ? (
            <p className='bg-parchment py-8 px-12 fz-12 radius-4'>
              Primary market purchases can take up to 90 days while the property attempts to raise its required capital. Once this amount has been raised, your transaction will be processed and your shares will be issued to you. If the property does not raise its capital goal, your transaction will be cancelled and your funds will be refunded in full.
            </p>
          ) : (
            <p className='bg-parchment py-8 px-12 fz-12 radius-4'>
              Our Realbricks market trades can take up to several days to fully process. Once we have verified that the shares you are attempting to
              purchase can be safely transferred to you, the order will be processed. If this cannot be completed, your transaction will be cancelled,
              and your funds be refunded in full.
            </p>
          )}
        </>
      )}
      {(transactionType === 'Deposit' || transactionType === 'Withdrawal') && (
        <>
          <p className='fw-600 mb-0'>Transaction:</p>
          <p className='mb-40 text-taupe'>{`${transactionType} - $${getUsCurrencyFormat(amount)}`} </p>
        </>
      )}
      {(transactionType === 'Bought' || transactionType === 'Sold') && (
        <>
          <p className='fw-600 mb-0'>Trade details:</p>
          <p className='mb-0 text-taupe'>
            {transactionType === 'Bought' ? 'Buy' : 'Sell'} - {tradeDetails?.marketPlace + ' Market'}{' '}
            {tradeDetails?.marketPlace !== 'Secondary' && '(Initial Offering)'}{' '}
          </p>
          <p className='mb-0 text-taupe'>
            {tradeDetails?.noOfShares} Share(s) : {tradeDetails?.propertyName + ' '}
            {/* {tradeDetails?.address}{' '} */}
          </p>
          <p className='mb-0 text-taupe'>
            Price per share: ${getUsCurrencyFormat(pricePerShare)}
          </p>
          <p className='mb-0 text-taupe'>
            Share(s) Price: ${getUsCurrencyFormat(amountWithoutFee)}
          </p>
          {(tradeDetails?.marketPlace === 'Secondary') && (
            <p className='mb-0 text-taupe'>
              Transaction Fee: ${getUsCurrencyFormat(transactionFee)}
            </p>
          )}
          <p className='mb-0 text-taupe'>
            Platform Fee: ${getUsCurrencyFormat(platformFee)}
          </p>
          {(tradeDetails?.marketPlace === 'Primary') && (
            <p className='mb-0 text-taupe'>
              Total Cost: ${getUsCurrencyFormat(amountWithoutFee + platformFee)}
            </p>
          )}
          {(tradeDetails?.marketPlace === 'Secondary') && (
            transactionType === 'Bought' ? (
              <div>
                Total Cost : ${getUsCurrencyFormat(amountWithoutFee + platformFee + transactionFee)}
              </div>
            ) : (
              transactionType === 'Sold' && (
               <p className='mb-0 text-taupe'>
                  Total Amount to Seller (less fees): ${getUsCurrencyFormat(amountWithoutFee - platformFee - transactionFee)}
                </p>
              )
            )
          )}
        </>
      )}
      {transactionType === 'Dividend' && (
        <>
          <p className='fw-600 mb-0'>Dividend details:</p>
          <p className='text-taupe'>
            {dividendDetails?.noOfShares} share(s): {dividendDetails?.propertyName + ' '}
            {dividendDetails?.address}
            <p className='mb-0'>Dividend Per Share : ${getUsCurrencyFormat(amount / dividendDetails?.noOfShares)}</p>
            Total Dividend : ${getUsCurrencyFormat(amount)}
            <p>Payout Date : {dividendDetails?.payoutDate}</p>
          </p>
        </>
      )}
      {/* Temp. Comment As per the CR changes (Remove the lower section and View Order button (currently its going back to the Portfolio page)) */}
      {/* {transactionType !== 'Deposit' && transactionType !== 'Withdrawal' && (
        <>
          <p className='text-taupe'>For more information, please visit your Order page.</p>
          <Button className='w-100' onClick={() => navigate('/portfolio')}>
            View Order
          </Button>
        </>
      )} */}
    </Modal>
  );
};
export default TransactionDetailsModal;
